module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segment"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title is-uppercase"
  }, [_vm._v(_vm._s(_vm.PlayerData.player.name))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Position: " + _vm._s(_vm.PlayerData.player.position))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Handedness: " + _vm._s(_vm.PlayerData.player.handedness))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Age: " + _vm._s(_vm.PlayerData.player.age))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Nationality: " + _vm._s(_vm.PlayerData.player.birth_place))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tabs is-fullwidth"
  }, [_c('ul', [_c('li', {
    class: {
      'is-active': _vm.selected == 'overview',
      'is-primary': _vm.selected != 'overview'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'overview';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Overview")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'game-logs',
      'is-primary': _vm.selected != 'game-logs'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'game-logs'
      }
    }
  }, [_vm._v("Game Logs")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'power-play',
      'is-primary': _vm.selected != 'power-play'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'power-play';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Power Play")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'points',
      'is-primary': _vm.selected != 'points'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'points';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Points")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'shots',
      'is-primary': _vm.selected != 'shots'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'shots';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Shooting")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'faceoffs',
      'is-primary': _vm.selected != 'faceoffs'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'faceoffs';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Faceoffs")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'turnovers',
      'is-primary': _vm.selected != 'turnovers'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'turnovers';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Turnovers")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'hits',
      'is-primary': _vm.selected != 'hits'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'hits';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Hits")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'toi',
      'is-primary': _vm.selected != 'toi'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'toi';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Time On Ice")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.selected == 'pims',
      'is-primary': _vm.selected != 'pims'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selected = 'pims';
        _vm.fetchPlayerStats()
      }
    }
  }, [_vm._v("Penalty Minutes")])])])]), _vm._v(" "), (_vm.selected === 'overview') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_goals))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_total))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shot_attempts))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_points))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_shifts))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_sot))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'game-logs') ? _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('apexchart', {
    ref: "game_logs_chart",
    attrs: {
      "type": "line",
      "height": "350",
      "options": _vm.GameLogsCharOptions,
      "series": _vm.gameLogsChart
    }
  })], 1), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/player-stats/game-logs/",
      "postData": [{
        year: 2021,
        competition: 'EIHL',
        venue: 0,
        player_id: this.$route.params.player_id,
        team_id: 1
      }],
      "selectedData": [{
          title: 'Date',
          prop: 'game_date'
        },
        {
          title: 'G',
          prop: 'goals'
        },
        {
          title: 'PA',
          prop: 'first_assist'
        },
        {
          title: 'SA',
          prop: 'second_assist'
        },
        {
          title: 'PPTS',
          prop: 'primary_points'
        },
        {
          title: 'P',
          prop: 'points',
        },
        {
          title: 'PPG',
          prop: 'pp_goals'
        },
        {
          title: 'PPP',
          prop: 'pp_points'
        },
        {
          title: 'SHG',
          prop: 'sh_goals'
        },
        {
          title: 'SHP',
          prop: 'sh_points'
        },
        {
          title: 'SOG',
          prop: 'shots_on_net'
        },
        {
          title: 'SHOTS +',
          prop: 'shots_for'
        },
        {
          title: 'SHOTS -',
          prop: 'shots_against'
        },
        {
          title: 'SHOTS +/-',
          prop: 'shots_diff'
        },
        {
          title: 'TOI',
          prop: 'toi_total'
        },
        {
          title: 'Shifts',
          prop: 'toi_shifts'
        },
        {
          title: 'PIMT',
          prop: 'pim_taken'
        },
        {
          title: 'PIMD',
          prop: 'pim_drawn'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selected === 'points') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_points))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_goals))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_first_assists))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_second_assists))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_assists))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_points))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_goals_60))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_first_assists_60))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_second_assists_60))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_assists_60))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_points_60))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'power-play') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_shots))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_goals))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_first_assists))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_second_assists))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_assists))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_points))])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shot_attempts))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_sot))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shooting_percentage) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shot_percentage) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_shifts))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_shifts_avg))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_pp_per_game))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('ShotsHeatmap')], 1)])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'shots') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_shots))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shot_attempts))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shot_percentage))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_sot))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_sot_percentage))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shooting_percentage))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shots_for))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shots_against))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shots_diff))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_goals_percentage))])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shot_60))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_sot_60))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shots_for_60))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_shots_against_60))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'faceoffs') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_faceoffs))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_fo_taken))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_fo_win))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_fo_loss))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_fo_total_win_percentage) + " %")])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_fo_t_percentage) + " %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_fo_win_percentage) + " %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_fo_loss_percentage) + " %")])])])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'turnovers') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_turnovers))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_total))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_ozone))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_nzone))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_dzone))])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_total_percentage) + " %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_ozone_percentage) + " %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_nzone_percentage) + " %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_to_dzone_percentage) + " %")])])])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'hits') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_hits))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_hits))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_hits_per_game))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_hits_sixty))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_hits_vs_team) + "%")])]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_hits_eh))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_hits_pp))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_hits_sh))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'toi') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_toi))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_total))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_per_game))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_avg_shift))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_shifts))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_shifts_avg))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_eh))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_pp))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_sh))])]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_eh_per_game))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_pp_per_game))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_sh_per_game))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_eh_shifts))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_pp_shifts))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_sh_shifts))])]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_eh_shifts_gp))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_pp_shifts_gp))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_sh_shifts_gp))])])]), _vm._v(" "), _c('h2', {
    staticClass: "stat-category has-text-centered"
  }, [_vm._v("Team %")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team_eh) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team_pp) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team_sh) + "%")])]), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team_shifts) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team_shifts_eh) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team_shifts_pp) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_toi_team_shifts_sh) + "%")])])])]) : _vm._e(), _vm._v(" "), (_vm.selected === 'pims') ? _c('div', [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.gp_pims))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_count))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_count))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_minutes))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_minutes))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_minutes_minor))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_minutes_minor))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_minutes_major))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_minutes_major))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_minutes_misconduct))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_minutes_misconduct))])]), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_per_game))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_per_game))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_per_game_minor))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_per_game_minor))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_per_game_major))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_per_game_major))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_per_game_misconduct))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_per_game_misconduct))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_per_sixty))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_per_sixty))])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-centered"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_team_percentage) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_team_percentage) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_team_percentage_minor) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_team_percentage_minor) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_team_percentage_major) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_team_percentage_major) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_team_percentage_misconduct) + "%")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_team_percentage_misconduct) + "%")])]), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-number"
  }, [_vm._v("-")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_minutes_ozone))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_minutes_ozone))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_minutes_nzone))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_minutes_nzone))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_taken_minutes_dzone))]), _vm._v(" "), _c('h2', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.PlayerData.player_pens_drawn_minutes_dzone))])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("2021 / 2022")])])])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    attrs: {
      "disabled": ""
    }
  }, [_c('option', [_vm._v("EHIL & Challenge Cup")])])])]), _vm._v(" "), _c('small', [_vm._v("All Situations - Unless specified")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-1"
  }, [_c('figure', {
    staticClass: "image is-128x128"
  }, [_c('img', {
    staticClass: "is-rounded",
    attrs: {
      "src": "https://devils.roblutken.com/devils/assets/player-pictures/Cardiff_Devils.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Goals")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Total Time On Ice")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shot Attempts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Points")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shots On Target")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Goals")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Primary Assists")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Secondary Assists")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Assists")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Points")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Goals / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("First Assists / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Second Assists / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Assists / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Points / 60")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Goals")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PA")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SA")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Assists")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Points")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shot Attempts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SOT")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SOT %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("TOI")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("AVG Shift")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("AVG / G")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shot_attempts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Shots")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SOT")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SOT %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH %")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shots For")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shots Against")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shots Diff")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Goals")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shots / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SOT / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shots For / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shots Against / 60")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Won")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Lost")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Win %")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% Team FO Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% Team FO Win")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% Team FO Lost")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Total")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("O-Zone")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("N-Zone")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("D-Zone")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% Team")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% Team O-Zone")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% Team N-Zone")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% Team D-Zone")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Hits")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Hits Per Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Hits Per 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v(" % of Team Hits")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("EH")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Total TOI")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("AVG TOI")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("AVG Shift")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("AVG Shift / G")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("EH TOI")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PP TOI")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH TOI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-3"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("EH AVG")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PP AVG")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH AVG")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("EH Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PP Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH Shifts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-3"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("EH Shifts AVG")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PP Shifts AVG")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH Shifts AVG")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Total Time")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("EH Time")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PP Time")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH Time")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-3"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("EH Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("PP Shifts")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("SH Shifts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2 is-3"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("GP")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("No. Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("No. Drawn")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken Minor")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn Minor")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken Major")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn Major")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken Misconduct")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn Misconduct")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-4"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken Minor / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn Minor / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken Major / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn Major / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken Misconduct / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn Misconduct / Game")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Taken / 60")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins Drawn / 60")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-offset-2 is-3"
  }, [_c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Drawn")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Taken Minor")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Drawn Minor")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Taken Major")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Drawn Major")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Taken Misconduct")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("% of Team Drawn Misconduct")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-4"
  }, [_c('h2', {
    staticClass: "stat-category has-text-centered"
  }, [_vm._v("Major & Minor Only")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins O-Zone Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins O-Zone Drawn")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins N-Zone Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins N-Zone Drawn")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins D-Zone Taken")]), _vm._v(" "), _c('h2', {
    staticClass: "stat-title"
  }, [_vm._v("Mins D-Zone Drawn")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f158d56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/season-stats/player-report.vue
// module id = 642
// module chunks = 30